import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const REFS = [
  ['EuRoC MAV dataset. M. Burri et al., The EuRoC micro aerial vehicle datasets, IJRR 2016.', 'https://projects.asl.ethz.ch/datasets/euroc-mav/', 'projects.asl.ethz.ch/datasets/euroc-mav'],
  ['TUM-VI benchmark. D. Schubert et al., The TUM VI Benchmark for Evaluating Visual-Inertial Odometry, IROS 2018.', 'https://arxiv.org/abs/1804.06120', 'arxiv.org/abs/1804.06120'],
  ['Project Aria hardware specification, Meta.', 'https://facebookresearch.github.io/projectaria_tools/docs/tech_spec/hardware_spec', 'facebookresearch.github.io/projectaria_tools/docs/tech_spec/hardware_spec'],
  ['ORB-SLAM3 code and settings: src/Tracking.cc, Examples/Monocular-Inertial/EuRoC.yaml.', 'https://github.com/UZ-SLAMLab/ORB_SLAM3/blob/4452a3c4ab75b1cde34e5505a36ec3f9edcdc4c4', 'github.com/UZ-SLAMLab/ORB_SLAM3 (commit 4452a3c)'],
  ['C. Campos et al., ORB-SLAM3: An Accurate Open-Source Library for Visual, Visual-Inertial and Multi-Map SLAM, IEEE T-RO 2021.', 'https://arxiv.org/abs/2007.11898', 'arxiv.org/abs/2007.11898'],
  ['Immediate Pose Recovery Method for Untracked Frames in Feature-Based SLAM (ORB-SLAM3 tracking coverage).', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10857547/', 'pmc.ncbi.nlm.nih.gov/articles/PMC10857547'],
  ['Video Depth Anything code and model.', 'https://github.com/DepthAnything/Video-Depth-Anything', 'github.com/DepthAnything/Video-Depth-Anything'],
  ['S. Chen et al., Video Depth Anything: Consistent Depth Estimation for Super-Long Videos, 2025.', 'https://arxiv.org/abs/2501.12375', 'arxiv.org/abs/2501.12375'],
];

export const Ref = ({ n, href }) => (
  <a href={href} target="_blank" rel="noreferrer" className="text-[#FF7A00] hover:text-[#FFD000] transition-colors">[{n}]</a>
);

// rows: [metric, plain, range, source(node), result]
export const BenchTable = ({ rows, testid }) => (
  <div className="overflow-x-auto rounded-2xl border border-white/10 bg-[#111111] mb-3">
    <table className="w-full text-sm border-collapse min-w-[720px]">
      <thead>
        <tr>{['Metric', 'Good range', 'Our result'].map((h) => (
          <th key={h} className="px-4 py-3 text-left font-mono text-[11px] tracking-[0.14em] uppercase text-white/40 font-semibold border-b border-white/10">{h}</th>
        ))}</tr>
      </thead>
      <tbody data-testid={testid}>
        {rows.map(([m, plain, range, src, res]) => (
          <tr key={m} className="border-t border-white/[0.06] first:border-t-0 hover:bg-white/[0.02] transition-colors">
            <td className="px-4 py-3.5 align-top w-[36%]"><b className="block text-white/90 font-semibold">{m}</b><span className="block text-xs text-white/45 mt-1 leading-relaxed">{plain}</span></td>
            <td className="px-4 py-3.5 align-top w-[38%]"><span className="block font-mono text-white/80">{range}</span><span className="block text-xs text-white/40 mt-1 leading-relaxed">{src}</span></td>
            <td className="px-4 py-3.5 align-top">
              <span className="block font-mono text-lg font-bold gradient-text w-fit">{res}</span>
              <span className="inline-flex items-center gap-1 text-[11px] text-emerald-400 mt-1"><CheckCircle2 size={12} />within range</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const References = () => (
  <ol className="list-decimal pl-5 space-y-2 text-xs text-white/45 leading-relaxed mt-6" data-testid="tech-references">
    {REFS.map(([t, href, label], i) => (
      <li key={i} id={`ref-${i + 1}`}>{t} <a href={href} target="_blank" rel="noreferrer" className="text-[#FF7A00] hover:text-[#FFD000] break-all">{label}</a></li>
    ))}
  </ol>
);
